module.exports = "../study/imgs/maps/Tokyo/S8/WaterEnvironment/Chlave/Tokyo_Chlave_MRI_RCP26_Mid.png";